import * as Sentry from "@sentry/react"
Sentry.init({
    dsn:
        process.env.REACT_APP_ENV === "local"
            ? ""
            : "https://4ed3372152bf5ba43c36f8babc22b5f1@statiq-sentry.statiq.co.in/4",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    release: process.env.REACT_APP_VERSION, // required for sourcemaps
    environment: process.env.REACT_APP_ENV, // define environment here
    sendDefaultPii: true,
    integrations: [
        // If you're using react router, use the integration for your react router version instead.
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Enable logs to be sent to Sentry
    enableLogs: process.env.REACT_APP_ENV === "local" ? false : true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})
